export default {
  title: 'Kurzbefehle',
  send_push_notification: {
    label: 'Push-Benachrichtigung senden',
    description: 'Neue Kampagne erstellen',
  },
  email_campaign: {
    label: 'E-Mail-Kampagne',
    description: 'An Abonnenten senden',
  },
  view_analytics: {
    label: 'Analysen anzeigen',
    description: 'Kampagnenleistung',
  },
};
